const state = {
    bonus: [],
    loading: false,
    bonusDelete: null,
};

export default state;